import { useQuery } from '@tanstack/react-query'
import { data } from '@portal/pkg-api/shared'
import { SharedApi } from '@portal/pkg-api/navigator'

const prefix = 'navigator.perspective'

export const PerspectiveQueries = {
  perspective: (id: number) => ({
    queryKey: [`${prefix}.perspective`, id],
    queryFn: () => data(SharedApi.getPerspective(id, { mercatusNotifyOnError: false })),
  }),
}

export function usePerspective(id?: number) {
  return useQuery({
    ...PerspectiveQueries.perspective(id!),
    enabled: id !== undefined,
  })
}
